import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import SpinningRoundedBorder from 'components/basic/animations/SpinningRoundedBorder';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { WalletType } from 'reduxState/wallet/walletUtils';

const MenuItemWrap = styled.li<{
  $disabled: boolean;
  $loading: boolean;
  $connected: boolean;
}>`
  padding: 14px 20px;
  display: flex;
  align-items: center;
  outline: none;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  border: 1px solid var(--elevation-light-border);
  background: var(--mainDark);

  border-radius: 5px;

  ${({ $connected }) => ($connected ? 'border-color: var(--main);' : '')}

  ${({ $disabled }) =>
    $disabled
      ? css`
          pointer-events: none;
        `
      : ''}

  &:focus,
  &:hover {
    border-color: var(--main);
    background-color: var(--primary7);
  }
  /* Disable focus on mobile devices */
  @media (pointer: coarse) {
    &:focus,
    &:hover {
      background-color: initial;
    }
  }
  &:active {
    opacity: 0.6;
  }
  > img {
    height: 30px;
    width: 30px;
    object-fit: contain;
  }

  ${({ $disabled, $loading }) =>
    $disabled && !$loading ? 'opacity: 0.3;' : ''};
`;

const ItemTitle = styled.div`
  flex: 1;
  margin-left: 20px;
`;

type ItemProps = {
  onSelect: ({ type, rdns }: { type: WalletType; rdns?: string }) => void;
  title: string;
  icon: string;
  connected: boolean;
  wallet: WalletType;
  walletRdns?: string;
  children?: ReactNode;
  preLoading: boolean;
  loading: boolean;
  disabled: boolean;
};

const WalletMenuItem = ({
  onSelect,
  title,
  wallet,
  walletRdns,
  children,
  connected,
  icon,
  preLoading,
  loading,
  disabled,
}: ItemProps) => {
  // const temporaryDisabled = wallet === 'walletConnect';
  // const disabled = disabledParam || temporaryDisabled;
  return (
    <MenuItemWrap
      tabIndex={disabled ? -1 : 0}
      onClick={
        disabled
          ? undefined
          : () => onSelect({ type: wallet, rdns: walletRdns })
      }
      $connected={connected}
      $disabled={disabled}
      $loading={loading || preLoading}
      // TODO: deprecated React event !
      onKeyPress={event => {
        if ((event.keyCode || event.which) === 13) {
          onSelect({ type: wallet, rdns: walletRdns });
        }
      }}
    >
      <img alt={title} src={icon} />
      <ItemTitle>
        {title}
        {children}
      </ItemTitle>
      {loading ? (
        <SpinningRoundedBorder size={20} />
      ) : connected ? (
        <MaterialSymbol icon="link" color="var(--green5)" />
      ) : null}
    </MenuItemWrap>
  );
};

export default WalletMenuItem;
